export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5121.0280d4d6.jpg";